import { Spin } from 'antd';
import React from 'react';

const Loading = ({ show, white }) => {
    if (!show) {
        return null;
    }

    return (
        <div className={white ? 'mask mask-white' : 'mask'}>
            <Spin size="large" />
        </div>
    );
};

export default Loading;
